const accountManagementStrings = {
  login: {
    emailFieldPlaceholder: 'Username',
    passwordFieldPlaceholder: 'Password',
    emailFieldValidationError: 'Please enter your username',
    passwordFieldValidationError: 'Please enter your password',
    loginBtn: 'Login',
  },
};

export default accountManagementStrings;
